
import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject, catchError, map, of} from 'rxjs';
import { CompleteUserDetails, User } from '../models/user.model';
import { CloudVendor } from '../models/cloud-vendor.model';
import { GetVendor } from '../interfaces/services/vendor.interface'
import { CloudVendorService } from './cloud-vendor.service';
import { RefreshVendor } from '../interfaces/services/vendor.interface';
import { AccountDetailRequest, AccountDetails, UpdateAccountDetailsRequest } from '../models/account-detail-request.model';
import { HttpService } from '../http.service';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { LocalStorageService } from './localstorage.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CloudProfileService implements GetVendor, RefreshVendor {

  private user: Subject<User> = new Subject<User>();
  private userName: Subject<string> = new Subject<string>();
  currentCloudVendor: BehaviorSubject<CloudVendor> = new BehaviorSubject<CloudVendor>(null);
  deletePanelDisplayStatus: BehaviorSubject<boolean> = new BehaviorSubject(false);
  cloudVendor;
  companyName: Subject<string> = new Subject<string>();

  constructor(private vendorSvc: CloudVendorService, private http: HttpService, private readonly localStorage: LocalStorageService,private readonly httpClient:HttpClient) {

  }

  updateUserName(name:string):void{
    
    this.userName.next(name)
  }

  getUserDetails(): Observable<User> {
    return this.http.get(environment.api.routes.account_detail.get);
  }

  getCompanyNameasObservable(): Observable<any> {
    return this.companyName.asObservable();
  }

  getCompleteUserDetails():Observable<CompleteUserDetails>{
    return this.http.get(environment.api.routes.account_detail.getUserDetails);
  }

  getUser(): Observable<User> {
    return this.user.asObservable();
  }

  getUserName(): Observable<string> {
    return this.userName.asObservable();
  }

  changeUserName(name) {
    this.user.next(name);
  }

  changeCompanyName(name) {
    this.companyName.next(name);
  }

  extractUserFromClaims(token: string) {
    if (token === null)
      return;

    const decoded: any = jwtDecode(token);

    if (this.localStorage.getItem(environment.constants.token) != null) {
      this.getUserDetails().subscribe(informtion => {
        this.user.next(informtion);
        this.userName.next(informtion.firstName)
        this.companyName.next(informtion.companyName);
      });
    }
    this.getVendorByName(decoded.actort).subscribe(vendor => {
      this.currentCloudVendor.next(vendor);
      this.cloudVendor = vendor;
    });
    return decoded;
  }

  setVendor(cloudVendor: CloudVendor) {
    this.currentCloudVendor.next(cloudVendor);
  }

  refreshVendor() {
    this.currentCloudVendor.next(this.cloudVendor);

  }
  getVendorByName(vendor: string): Observable<CloudVendor> {
    return this.vendorSvc.getVendorByName(vendor);
  }

  getAccountDetail(): Observable<AccountDetails> {
    return this.http.get(environment.api.routes.get_user_details);
  }

  updateAccountDetail(req: UpdateAccountDetailsRequest): Observable<boolean> {
    return this.http.put(environment.api.routes.account_detail.update, req);
  }

  updateAccountDetailDuringRegistration(req: AccountDetailRequest): Observable<number> {
    return this.http.put(environment.api.routes.user.register, req);
  }

}
